export default __webpack_public_path__ + "static/media/IC00001-mentor_icon.4df08917.svg";